import { Tag, Strategy } from "@phosphor-icons/react";
import * as React from "react";
import styles from "../Navbar.module.css";

export const MobileAgentsContent: React.FC = () => {
  return (
    <div className={styles.mobileDropdownContent}>
      <a href="/products/pricing-agent" className={styles.mobileDropdownItem}>
        <div className={`${styles.productIcon} ${styles.pricingAgentIcon}`}>
          <Tag size={19} weight="fill" />
        </div>
        <div className={styles.mobileDropdownItemText}>
          <div className={styles.mobileDropdownItemTitleRow}>
            <span className={styles.mobileDropdownItemTitle}>
              Pricing Agent
            </span>
            <span className={styles.dropdownItemBadge}>New</span>
          </div>
          <span className={styles.mobileDropdownItemDescription}>
            Get real-time pricing benchmarks and contract reviews
          </span>
        </div>
      </a>

      <a
        href="/products/negotiating-agent"
        className={styles.mobileDropdownItem}
      >
        <div className={`${styles.productIcon} ${styles.negotiationAgentIcon}`}>
          <Strategy size={19} weight="fill" />
        </div>
        <div className={styles.mobileDropdownItemText}>
          <div className={styles.mobileDropdownItemTitleRow}>
            <span className={styles.mobileDropdownItemTitle}>
              Negotiation Agent
            </span>
            <span className={styles.dropdownItemBadge}>New</span>
          </div>
          <span className={styles.mobileDropdownItemDescription}>
            Get personalized insights and autonomous negotiations
          </span>
        </div>
      </a>
    </div>
  );
};
